import { AssetBasicModel, useListAssetsQuery } from '@customer/store/apis/assetsApi';
import { useGetVehicleGroupsQuery } from '@customer/store/apis/metadataApi';
import { useMemo } from 'react';

interface CustomInvestigationDependencies {
  assets: AssetBasicModel[] | undefined;
  isLoaded: boolean;
  renderKey: string;
}

export const useLoadCustomInvestigationDependencies = (): CustomInvestigationDependencies => {
  const { data } = useListAssetsQuery(
    { query: {} },
    {
      refetchOnMountOrArgChange: 60,
    },
  );

  const { items: assets } = data ?? {};

  const { data: assetGroups } = useGetVehicleGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const isLoaded = [assets, assetGroups].every(Boolean);

  const renderKey = useMemo<string>(() => {
    const assetIds = assets?.map(asset => asset.id);
    const assetGroupIds = assetGroups?.map(group => group.id);
    return JSON.stringify({ assets: assetIds, assetGroups: assetGroupIds });
  }, [assets, assetGroups]);

  return {
    assets,
    isLoaded,
    renderKey,
  };
};
